'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { hapticImpact } from '@/lib/tma';

const TABS = [
  { href: '/markets/', key: 'markets', label: 'РЫНКИ' },
  { href: '/profile/', key: 'me', label: 'Я' },
] as const;

export function BottomNav() {
  const pathname = usePathname();

  // Скрываем bottom nav на landing-странице (public visitors)
  if (pathname === '/' || pathname === '') return null;

  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 bg-bg-base border-t border-line">
      <div className="max-w-md mx-auto flex h-16">
        {TABS.map((tab) => {
          const active = pathname.startsWith(tab.href);
          return (
            <Link
              key={tab.key}
              href={tab.href}
              onClick={() => hapticImpact('light')}
              className={`flex-1 flex items-center justify-center display text-[10px] tracking-[0.1em] relative ${
                active ? 'text-accent' : 'text-text-tertiary'
              }`}
            >
              {active && (
                <div className="absolute top-1.5 w-6 h-[3px] bg-accent" />
              )}
              {tab.label}
            </Link>
          );
        })}
      </div>
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
}
